import React, { useMemo, useState, useEffect } from 'react'
import tw, { css } from 'twin.macro'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import Chip, { ChipVariant } from '@components/DesignSystem/Chip'
import { useTranslation } from '@i18n'
import { useArticleContext } from '../_core'
import Label from '../_shared/Label'

export interface CategoryData {
  id?: string
  name?: string
}

interface CategoryChoiceProps {
  categories: CategoryData[]
}

export default function CategoryChoice({ categories = [] }: CategoryChoiceProps) {
  const { articleState, updateSelectCategory } = useArticleContext()
  const isTouched = React.useRef(false)
  const { t } = useTranslation('editor')
  const articleStateCategoryId = get(articleState, 'categoryIds[0]')
  const articleStateCategory = useMemo<CategoryData>(() => {
    if (isEmpty(categories) || isEmpty(articleState?.categoryIds)) return {}
    return categories.find((category) => category.id === articleStateCategoryId)
  }, [categories, articleStateCategoryId])

  // 用一個 local state 存，讓 storybook 也可以正常運作
  const [selectedCategory, setSelectedCategory] = useState(articleStateCategory)
  useEffect(() => {
    setSelectedCategory(articleStateCategory)
  }, [articleStateCategory])

  const handleChipOnClick = (val: CategoryData) => {
    setSelectedCategory(val)
    updateSelectCategory(val.id)
  }

  const handleDisclosureClick = () => {
    isTouched.current = true
  }

  return (
    <div tw="space-y-4">
      <div
        tw="w-full flex justify-between items-center focus:outline-none"
        onClick={handleDisclosureClick}
      >
        <Label $required>{t(['category.label'])}</Label>
      </div>
      <div css={[tw`flex flex-wrap`, gapStyle]}>
        {categories.map((val) => (
          <Chip
            key={val.id}
            variant={selectedCategory.id === val.id ? ChipVariant.activated : undefined}
            onClick={() => handleChipOnClick(val)}
          >
            {val.name}
          </Chip>
        ))}
      </div>
    </div>
  )
}

const gapStyle = css`
  & > * {
    ${tw`mr-2 mb-2`}
  }
`
